module.exports = __webpack_public_path__ + "static/media/banditCommander.ad6dafcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/bosses/banditCommander.jpg
// module id = 139
// module chunks = 0